const ITEMS = [
  "MOBILE APP DEVELOPMENT",
  "CUSTOM WEBSITES",
  "FULL-STACK ENGINEERING",
  "UI/UX CRAFT",
  "CALGARY · ALBERTA",
  "WE BRING IDEAS TO LIFE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-mono text-sm sm:text-base tracking-[0.22em] text-zinc-500 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="text-teal-500/70 text-xs">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="marquee-strip"
    className="relative border-y border-zinc-800/70 bg-[#17181c] py-5 overflow-hidden"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
